import { ExceptionUtils } from "#src/utils/exception";
import { Card, EmptyState, Skeleton } from "@validereinc/common-components";
import classNames from "classnames/bind";
import * as PropTypes from "prop-types";
import { default as React, Suspense, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import styles from "./Map.module.scss";

const cx = classNames.bind(styles);
const MapContent = lazy(() => import("./MapContent.tsx"));

const MapErrorFallback = () => {
  return (
    <Card>
      <EmptyState
        variant={"error"}
        title="Map Unavailable"
        suggestion="Something went wrong. Please refresh the page."
      />
    </Card>
  );
};

const MapLoadingFallback = () => {
  return (
    <Skeleton
      isLoading
      className={cx("map-loading")}
    >
      <Card className={cx("map-skeleton")}>
        <></>
      </Card>
    </Skeleton>
  );
};

const Map = (props) => {
  return (
    <ErrorBoundary
      FallbackComponent={MapErrorFallback}
      onError={(e) => {
        console.error("Error loading mapbox", e);
        ExceptionUtils.reportException(e, "error", {
          hint: "Error loading Mapbox",
        });
      }}
    >
      <Suspense fallback={<MapLoadingFallback />}>
        <MapContent
          {...props}
          ErrorFallback={MapErrorFallback}
          LoadingFallback={MapLoadingFallback}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

Map.defaultProps = {
  overrideHeight: null,
  subtractFromHeightOnResize: 0,
};

Map.propTypes = {
  initialViewState: PropTypes.object.isRequired,
  overrideHeight: PropTypes.number, // overrides auto MapResizer allowing setting of the height directly
  subtractFromHeightOnResize: PropTypes.number, // helps MapResizer when the parent height changes and Map is used in a panel
  children: PropTypes.element,
  style: PropTypes.object,
};

export default Map;
